export default "__VITE_ASSET__CYeiK_Ey__"